
import { SET_PROGRAMARI, DELETE_PROGRAMARE, ACCEPTARE_PROGRAMARE, ADD_PROGRAMARE, EDIT_PROGRAMARE } from './ProgramariMutations'

import api from '@/api'

export default {
  loadProgramari ({ commit }, payload) {
    api
      .loadProgramari()
      .then(response => commit(SET_PROGRAMARI, response))
      .catch(error => {
        console.log('Error: ', error)
      })
  },
  deleteProgramare ({ commit }, payload) {
    api.deleteProgramare(payload)
    commit(DELETE_PROGRAMARE, payload)
  },
  acceptareProgramare ({ commit }, payload) {
    api.acceptareProgramare(payload)
    commit(ACCEPTARE_PROGRAMARE, payload)
  },
  editProgramare ({ commit }, payload) {
    api.editProgramare(payload)
    commit(EDIT_PROGRAMARE, payload)
  },
  addProgramare ({ commit }, payload) {
    api.addProgramare(payload)
    commit(ADD_PROGRAMARE, payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/programari/ProgramariActions.js